<template>
   <div>
       机构设置222222
   </div>
</template>

<script>
  
  export default {
    name:'two',
    data(){
      return {
       
      }
    },
   
    methods: {
      
    }
  }
</script>

<style>

</style>